export default {
    secondVisit: 'Second Visit',
    date: 'Date',
    mama: 'Mama',
    complaintAndAssessment: 'Complaint And Assessment',
    nextAppointment: 'Next Appointment',
}